import { render, staticRenderFns } from "./DormDashboardHead.vue?vue&type=template&id=3663ec6e&"
import script from "./DormDashboardHead.vue?vue&type=script&lang=js&"
export * from "./DormDashboardHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports